import { useState, useEffect } from "react";
import {
  Button,
  Form,
  Spinner,
  Row,
  Col,
  Modal,
} from "react-bootstrap";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import Select from 'react-select';


export default function CreateUserMngt({ show, closeModal, refreshPage }) {
  const [roles, setRoles] = useState([]);
  const [userType, setuserType] = useState([]);
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [warehouse, setWarehouse] = useState([]);
  const [toggle, setToggle] = useState(false);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    password_confirmation: "",
    role: "",
    user_type_id: "",
    warehouse_ids: [],

  });

  useEffect(() => {
    const fetchRolesAndPermissions = async () => {
      try {
        const user_type = await axiosInstance.get(`/user/auth/get_user_type`);
        const rolesResponse = await axiosInstance.get("/user/roles");
        const filteredRoles = rolesResponse.data.data.roles.filter(
          (role) => role.name !== "Customers"
        );
        const house = await axiosInstance.get('/user/warehouses/get_warehouse');
        setWarehouse(house.data.data.warehouse);

        // Set the state with the filtered roles and user types
        setuserType(user_type.data.data.user_type || []);
        setRoles(filteredRoles);
      } catch (error) {
        toast.error("Error fetching roles or user types.");
      }
    };

    fetchRolesAndPermissions();
  }, []);



  const resetForm = () => {
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      password: "",
      password_confirmation: "",
      role: "",
      user_type_id: "",
      warehouse_id: "",

    });
    setValidationError({});
  };

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axiosInstance.post("/user/auth/register", formData);
      handleClose();
      refreshPage();
      toast.success("User saved successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.response && error.response.data.errors) {
        setValidationError(error.response.data.errors);
        toast.error("Failed to save user.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="CreateUserMngt">
      <Modal show={show} onHide={handleClose} dialogClassName="modal-lg">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add New User and Assign Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Oval
              className="d-flex justify-content-center align-items-center"
              height={80}
              width={80}
              color="#FF0200"
              visible={isLoading}
              ariaLabel="oval-loading"
              secondaryColor="#4fa94d"
              strokeWidth={2}
              strokeWidthSecondary={2}
            /> */}
            <Row>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    isInvalid={!!validationError.first_name}
                  />
                  {validationError.first_name && (
                    <Form.Control.Feedback type="invalid">
                      {validationError.first_name[0]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formLastName">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    isInvalid={!!validationError.last_name}
                  />
                  {validationError.last_name && (
                    <Form.Control.Feedback type="invalid">
                      {validationError.last_name[0]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter..."
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!validationError.email}
                  />
                  {validationError.email && (
                    <Form.Control.Feedback type="invalid">
                      {validationError.email[0]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formPhoneNumber">
                  <Form.Label>Phone Number</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="phone"
                    onChange={handleChange}
                  />

                  {validationError.phone && (
                    <Form.Control.Feedback type="invalid">
                      {validationError.phone[0]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <div className="position-relative auth-pass-inputgroup">
                  <Form.Label>Password</Form.Label>
                  <input
                    type={toggle ? `text` : `password`}
                    className={`form-control pe-5 password-input ${validationError.password ? "is-invalid" : ""
                      }`}
                    placeholder="Enter password"
                    aria-describedby="passwordInput"
                    onChange={handleChange}
                    value={formData.password}
                    name="password"
                  />
                  <button
                    className="btn btn-link position-absolute end-0 text-decoration-none text-muted password-addon"
                    type="button"
                    onClick={handleToggle}
                    style={{ top: "30px" }}
                  >
                    <i className={toggle ? `ri-eye-off-fill` : `ri-eye-fill`} />
                  </button>
                  {validationError.password && (
                    <div className="invalid-feedback">
                      {validationError.password[0]}
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <div className="position-relative auth-pass-inputgroup">
                  <Form.Label>Confirm Password</Form.Label>
                  <input
                    type={toggle ? `text` : `password`}
                    className={`form-control pe-5 password-input ${validationError.password_confirmation ? "is-invalid" : ""
                      }`}
                    placeholder="Enter password"
                    aria-describedby="passwordInput"
                    onChange={handleChange}
                    value={formData.password_confirmation}
                    name="password_confirmation"
                  />
                  <button
                    className="btn btn-link position-absolute end-0 text-decoration-none text-muted password-addon"
                    type="button"
                    onClick={handleToggle}
                    style={{ top: "30px" }}
                  >
                    <i className={toggle ? `ri-eye-off-fill` : `ri-eye-fill`} />
                  </button>
                  {validationError.password_confirmation && (
                    <div className="invalid-feedback">
                      {validationError.password_confirmation[0]}
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formRole">
                  <Form.Label>Role</Form.Label>
                  <Form.Select
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    isInvalid={!!validationError.role}
                  >
                    <option value="">--select role--</option>
                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </Form.Select>
                  {validationError.role && (
                    <Form.Control.Feedback type="invalid">
                      {validationError.role[0]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formUserType">
                  <Form.Label>User Type</Form.Label>
                  <Form.Select
                    name="user_type_id"
                    value={formData.user_type_id}
                    onChange={handleChange}
                    isInvalid={!!validationError.user_type_id}
                  >
                    <option value="">--select user type--</option>
                    {userType.map((usertype) => (
                      <option key={usertype.id} value={usertype.id}>
                        {usertype.user_type_name}
                      </option>
                    ))}
                  </Form.Select>
                  {validationError.user_type_id && (
                    <Form.Control.Feedback type="invalid">
                      {validationError.user_type_id[0]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>


              {/* {((formData.role === "8" && formData.user_type_id === "8") ||
                (formData.user_type_id === "3" && formData.role === "3") ||
                (formData.role === "10" && formData.user_type_id === "10") ||
                (formData.role === "6" && formData.user_type_id === "5")) && (
                <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                  <Form.Group controlId="warehouseInput">
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text"> Warehouse</span>
                      </div>
                      <select
                        className="form-control custom-select"
                        name="warehouse_id"
                        value={formData.warehouse_id}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Warehouse Name --</option>
                        {warehouse.map((ware) => (
                          <option key={ware.id} value={ware.id}>
                            {ware.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {validationError.warehouse_id && (
                      <small className="text-danger my-1">
                        {validationError.warehouse_id[0]}
                      </small>
                    )}
                  </Form.Group>
                </Col>
              )} */}

              {((formData.role === "8" && formData.user_type_id === "8") ||
                (formData.user_type_id === "3" && formData.role === "3") ||
                (formData.role === "10" && formData.user_type_id === "10") ||
                (formData.role === "6" && formData.user_type_id === "5")) && (

                  formData.user_type_id === "3" && formData.role === "3" ? (
                    // Sales Supervisor → multi-select

              // ...

                <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                  <Form.Group controlId="warehouseInput">
                    <Form.Label>Assign Warehouses (Multiple Allowed)</Form.Label>

                    <Select
                      isMulti
                      options={warehouse.map(ware => ({ value: ware.id, label: ware.name }))}
                      value={warehouse
                        .filter(ware => formData.warehouse_ids?.includes(ware.id))
                        .map(ware => ({ value: ware.id, label: ware.name }))
                      }
                      onChange={(selectedOptions) => {
                        const selectedIds = selectedOptions.map(option => option.value);
                        setFormData(prev => ({ ...prev, warehouse_ids: selectedIds }));
                      }}
                      placeholder="Select warehouses..."
                    />

                    {validationError.warehouse_ids && (
                      <small className="text-danger">{validationError.warehouse_ids[0]}</small>
                    )}
                  </Form.Group>
                </Col>
                  ) : (
                    // Other roles → single select
                    <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                      <Form.Group controlId="warehouseInput">
                        <Form.Label>Warehouse</Form.Label>
                        <Form.Select
                          name="warehouse_ids"
                          value={formData.warehouse_ids?.[0] || ""}
                          onChange={(e) =>
                            setFormData(prev => ({
                              ...prev,
                              warehouse_ids: [e.target.value]
                            }))
                          }
                        >
                          <option value="">-- Select Warehouse --</option>
                          {warehouse.map((ware) => (
                            <option key={ware.id} value={ware.id}>
                              {ware.name}
                            </option>
                          ))}
                        </Form.Select>
                        {validationError.warehouse_ids && (
                          <small className="text-danger">
                            {validationError.warehouse_ids[0]}
                          </small>
                        )}
                      </Form.Group>
                    </Col>
                  )
                )}


            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              {isLoading ? <Spinner animation="border" size="sm" /> : "Save"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
